// IE 2026 11 02 / ODOO-349799 (sort-nulls): пустые значения числовой колонки — ПЕРЕД нулём и числами по возрастанию, ПОСЛЕ — по убыванию.
// Причина (Игорь, «Конфігурація», чипс «Кількість» ASC: числа 92 897 … 2 065 825 наверху, пустые ячейки ниже): wijmo CollectionView
// рождается с sortNulls = SortNulls.Last (@mescius/wijmo index.js, конструктор: `this._srtNulls=SortNulls.Last`) — null/undefined всегда
// в хвосте, независимо от направления; '' wijmo за null не считает и сравнивает со строкой/числом как строку (''<0 ложь, ''>0 ложь → 0,
// то есть «где попало»). Здесь — sortComparer CollectionView (wijmo зовёт его ПОСЛЕ sortConverter, по уже преобразованным значениям,
// и применяет ascending сам: `c.ascending?+s:-s`): пара «пусто ↔ число» и «пусто ↔ пусто» сравнивается естественно (null < любое
// число, включая 0), остальные пары (строки, даты, «пусто ↔ строка») — null → штатный порядок wijmo без изменений.
// Дерево (childItemsPath) сортируется своим hierSort_comparator — там пустые и так в корзине 0 (естественно); группы (groupDescriptions)
// wijmo собирает ПОСЛЕ сортировки строк — comparer их не трогает.
// Выключатель fe.ux.gridSortNullsFirst (по умолчанию ВКЛ; false — поведение до правки: sortNulls.Last).

export const GRID_SORT_NULLS_FLAG = 'fe.ux.gridSortNullsFirst'

export function gridSortNulls_on(store) {
    try { return store?.setting?.(GRID_SORT_NULLS_FLAG, true) !== false } catch (e) { return true }
}

// пусто: null / undefined / '' / NaN
export function sortNulls_isEmpty(v) {
    return v === null || v === undefined || v === '' || (typeof v === 'number' && Number.isNaN(v))
}

// comparer для CollectionView.sortComparer: число (или null — «решай сам, wijmo») по ВОЗРАСТАНИЮ; направление wijmo накладывает сам
export function sortNulls_compare(a, b) {
    const ea = sortNulls_isEmpty(a), eb = sortNulls_isEmpty(b)
    if (ea && eb) return 0
    if (ea) return typeof b === 'number' ? -1 : null
    if (eb) return typeof a === 'number' ? 1 : null
    return null
}

// для прямого прогона (тест, сортировка массива): направление 'ASC' | 'DESC'
export function sortNulls_compareDir(a, b, direction = 'ASC') {
    let r = sortNulls_compare(a, b)
    if (r === null) {
        if (typeof a === 'number' && typeof b === 'number') r = a - b
        else r = String(a).localeCompare(String(b))
    }
    return direction === 'DESC' ? -r : r
}
